<template>
  <div style="font-size: 0.14rem">
    <popup title="腾讯充值隐私政策" :show="isShow">
      <div class="policy-popup">
        <p v-for="(item, index) in privacyPolicy" :key="index">{{ item }}</p>
        <p>
          详细信息请点击
          <a href="https://pay.qq.com/h5/store/privacy.html">《用户协议》</a>
          与
          <a href="https://pay.qq.com/h5/store/privacy-policy.html">《隐私协议》</a>
        </p>
        <button class="btn popup-button-primary" @click="handleConfirm">同意</button>
        <button class="btn popup-button-default" @click="handleCancel">拒绝</button>
      </div>
    </popup>
  </div>
</template>

<script>
import popup from "./popup.vue"
import * as invoiceConfig from "../../constants/invoice"

export default {
  name: "policyPopup",
  components: {
    popup
  },
  props: ["isShow"],
  methods: {
    handleCancel: function() {
      this.$emit("onCancel")
    },
    handleConfirm: function() {
      this.$emit("onConfirm")
    }
  },
  computed: {
    privacyPolicy() {
      let list =
        (invoiceConfig.staticConfig.privacyPolicy && invoiceConfig.staticConfig.privacyPolicy.split("<br />")) || []
      return list.map(item => item && item.replace("<br />", ""))
    }
  }
}
</script>
